import { AiOutlineDelete, AiOutlineDown, AiOutlineEdit } from "react-icons/ai";
import { FaCircle, FaCircleDot, FaCircleExclamation, FaElementor, FaHashnode, FaPlus } from "react-icons/fa6";
import { TbCircleNumber1, TbCircleNumber1Filled, TbHexagonNumber1Filled } from 'react-icons/tb';
import { RiNumber1 } from "react-icons/ri";
import { MdOutlineDataArray } from "react-icons/md";
import { RxComponentBoolean, RxText, RxTextAlignJustify } from "react-icons/rx";
import { FaRegCircle } from "react-icons/fa";
import { VscSymbolBoolean } from "react-icons/vsc";

export const NodeType = {
    NODE: 'NODE',
    CDATA: 'CDATA',
    ARRAY_NODE: 'ARRAY_NODE',
    ATTRIBUTE: 'ATTRIBUTE',
    MAPPED_ATTRIBUTE: 'MAPPED_ATTRIBUTE',
    MAPPED_BOOLEAN: 'MAPPED_BOOLEAN',
    MAPPED_NUMBER: 'MAPPED_NUMBER',
    MAPPED_TEXT: 'MAPPED_TEXT',
    PHANTOM_NODE: 'PHANTOM_NODE',
    PHANTOM_ARRAY_NODE: 'PHANTOM_ARRAY_NODE',
    SEQUENCE_ATTRIBUTE: 'SEQUENCE_ATTRIBUTE',
    SEQUENCE_NUMBER: 'SEQUENCE_NUMBER',
    SEQUENCE_TEXT: 'SEQUENCE_TEXT',
    STATIC_BOOLEAN: 'STATIC_BOOLEAN',
    STATIC_NUMBER: 'STATIC_NUMBER',
    STATIC_TEXT: 'STATIC_TEXT',
}

export const ActionType = {
    NODE: 'NODE',
    ADD_CHILD_NODE: 'ADD_CHILD_NODE',
    ADD_CHILD_CDATA: 'ADD_CHILD_CDATA',
    ADD_CHILD_ARRAY_NODE: 'ADD_CHILD_ARRAY_NODE',
    ADD_CHILD_PHANTOM_ARRAY_NODE : 'ADD_CHILD_PHANTOM_ARRAY_NODE',
    ADD_CHILD_PHANTOM_NODE: 'ADD_CHILD_PHANTOM_NODE',
    ADD_CHILD_MAPPED_BOOLEAN: 'ADD_CHILD_MAPPED_BOOLEAN',
    ADD_CHILD_STATIC_BOOLEAN: 'ADD_CHILD_STATIC_BOOLEAN',
    ADD_CHILD_MAPPED_NUMBER: 'ADD_CHILD_MAPPED_NUMBER',
    ADD_CHILD_STATIC_NUMBER: 'ADD_CHILD_STATIC_NUMBER',
    ADD_CHILD_SEQUENCE_NUMBER: 'ADD_CHILD_SEQUENCE_NUMBER',
    ADD_CHILD_MAPPED_TEXT: 'ADD_CHILD_MAPPED_TEXT',
    ADD_CHILD_STATIC_TEXT: 'ADD_CHILD_STATIC_TEXT',
    ADD_CHILD_SEQUENCE_TEXT: 'ADD_CHILD_SEQUENCE_TEXT',
    ADD_ATTRIBUTE: 'ADD_ATTRIBUTE',
    ADD_MAPPED_ATTRIBUTE: 'ADD_MAPPED_ATTRIBUTE',
    ADD_SEQUENCE_ATTRIBUTE: 'ADD_SEQUENCE_ATTRIBUTE',
    ABOVE_NODE: 'ABOVE_NODE',
    ADD_SIBLING_NODE_ABOVE: 'ADD_SIBLING_NODE_ABOVE',
    ADD_SIBLING_CDATA_ABOVE: 'ADD_SIBLING_CDATA_ABOVE',
    ADD_SIBLING_ARRAY_NODE_ABOVE: 'ADD_SIBLING_ARRAY_NODE_ABOVE',
    ADD_SIBLING_PHANTOM_NODE_ABOVE: 'ADD_SIBLING_PHANTOM_NODE_ABOVE',
    ADD_SIBLING_PHANTOM_ARRAY_NODE_ABOVE: 'ADD_SIBLING_PHANTOM_ARRAY_NODE_ABOVE',
    ADD_SIBLING_STATIC_BOOLEAN_ABOVE: 'ADD_SIBLING_STATIC_BOOLEAN_ABOVE',
    ADD_SIBLING_MAPPED_BOOLEAN_ABOVE: 'ADD_SIBLING_MAPPED_BOOLEAN_ABOVE',
    ADD_SIBLING_STATIC_NUMBER_ABOVE: 'ADD_SIBLING_STATIC_NUMBER_ABOVE',
    ADD_SIBLING_MAPPED_NUMBER_ABOVE: 'ADD_SIBLING_MAPPED_NUMBER_ABOVE',
    ADD_SIBLING_SEQUENCE_NUMBER_ABOVE: 'ADD_SIBLING_SEQUENCE_NUMBER_ABOVE',
    ADD_SIBLING_STATIC_TEXT_ABOVE: 'ADD_SIBLING_STATIC_TEXT_ABOVE',
    ADD_SIBLING_MAPPED_TEXT_ABOVE: 'ADD_SIBLING_MAPPED_TEXT_ABOVE',
    ADD_SIBLING_SEQUENCE_TEXT_ABOVE: 'ADD_SIBLING_SEQUENCE_TEXT_ABOVE',
    ADD_SIBLING_ATTRIBUTE_ABOVE: 'ADD_SIBLING_ATTRIBUTE_ABOVE',
    ADD_SIBLING_MAPPED_ATTRIBUTE_ABOVE: 'ADD_SIBLING_MAPPED_ATTRIBUTE_ABOVE',
    ADD_SIBLING_SEQUENCE_ATTRIBUTE_ABOVE: 'ADD_SIBLING_SEQUENCE_ATTRIBUTE_ABOVE',
    BELOW_NODE: 'BELOW_NODE',
    ADD_SIBLING_NODE_BELOW: 'ADD_SIBLING_NODE_BELOW',
    ADD_SIBLING_CDATA_BELOW: 'ADD_SIBLING_CDATA_BELOW',
    ADD_SIBLING_ARRAY_NODE_BELOW: 'ADD_SIBLING_ARRAY_NODE_BELOW',
    ADD_SIBLING_PHANTOM_NODE_BELOW: 'ADD_SIBLING_PHANTOM_NODE_BELOW',
    ADD_SIBLING_PHANTOM_ARRAY_NODE_BELOW: 'ADD_SIBLING_PHANTOM_ARRAY_NODE_BELOW',
    ADD_SIBLING_STATIC_BOOLEAN_BELOW: 'ADD_SIBLING_STATIC_BOOLEAN_BELOW',
    ADD_SIBLING_MAPPED_BOOLEAN_BELOW: 'ADD_SIBLING_MAPPED_BOOLEAN_BELOW',
    ADD_SIBLING_STATIC_NUMBER_BELOW: 'ADD_SIBLING_STATIC_NUMBER_BELOW',
    ADD_SIBLING_MAPPED_NUMBER_BELOW: 'ADD_SIBLING_MAPPED_NUMBER_BELOW',
    ADD_SIBLING_SEQUENCE_NUMBER_BELOW: 'ADD_SIBLING_SEQUENCE_NUMBER_BELOW',
    ADD_SIBLING_STATIC_TEXT_BELOW: 'ADD_SIBLING_STATIC_TEXT_BELOW',
    ADD_SIBLING_MAPPED_TEXT_BELOW: 'ADD_SIBLING_MAPPED_TEXT_BELOW',
    ADD_SIBLING_SEQUENCE_TEXT_BELOW: 'ADD_SIBLING_SEQUENCE_TEXT_BELOW',
    ADD_SIBLING_ATTRIBUTE_BELOW: 'ADD_SIBLING_ATTRIBUTE_BELOW',
    ADD_SIBLING_MAPPED_ATTRIBUTE_BELOW: 'ADD_SIBLING_MAPPED_ATTRIBUTE_BELOW',
    ADD_SIBLING_SEQUENCE_ATTRIBUTE_BELOW: 'ADD_SIBLING_SEQUENCE_ATTRIBUTE_BELOW',
    CHANGE_NODE_TYPE: 'CHANGE_NODE_TYPE',
    CHANGE_TO_NODE: 'CHANGE_TO_NODE', 
    CHANGE_TO_CDATA: 'CHANGE_TO_CDATA',
    CHANGE_TO_ARRAY_NODE: 'CHANGE_TO_ARRAY_NODE', 
    CHANGE_TO_PHANTOM_NODE: 'CHANGE_TO_PHANTOM_NODE', 
    CHANGE_TO_PHANTOM_ARRAY_NODE: 'CHANGE_TO_PHANTOM_ARRAY_NODE', 
    CHANGE_TO_STATIC_BOOLEAN: 'CHANGE_TO_STATIC_BOOLEAN', 
    CHANGE_TO_MAPPED_BOOLEAN: 'CHANGE_TO_MAPPED_BOOLEAN', 
    CHANGE_TO_STATIC_NUMBER: 'CHANGE_TO_STATIC_NUMBER', 
    CHANGE_TO_MAPPED_NUMBER: 'CHANGE_TO_MAPPED_NUMBER', 
    CHANGE_TO_SEQUENCE_NUMBER: 'CHANGE_TO_SEQUENCE_NUMBER', 
    CHANGE_TO_STATIC_TEXT: 'CHANGE_TO_STATIC_TEXT', 
    CHANGE_TO_MAPPED_TEXT: 'CHANGE_TO_MAPPED_TEXT', 
    CHANGE_TO_SEQUENCE_TEXT: 'CHANGE_TO_SEQUENCE_TEXT', 
    CHANGE_TO_ATTRIBUTE: 'CHANGE_TO_ATTRIBUTE', 
    CHANGE_TO_MAPPED_ATTRIBUTE: 'CHANGE_TO_MAPPED_ATTRIBUTE', 
    CHANGE_TO_SEQUENCE_ATTRIBUTE: 'CHANGE_TO_SEQUENCE_ATTRIBUTE', 
    DELETE_NODE: 'DELETE_NODE'
}

const MenuItem = (key: string, icon: JSX.Element, label: string ) => {
    return {key, icon, label};
}

const Menu = (key: string, icon: JSX.Element, label: string, children: any[] ) => {
    return {key, icon, label, children};
}

export const nodeItems = [
    Menu(ActionType.NODE, <FaPlus color={'#015b93'}/>, 'Add Child Node', [
        MenuItem(ActionType.ADD_CHILD_NODE, <FaElementor />, 'Add Node'),
        MenuItem(ActionType.ADD_CHILD_ARRAY_NODE, <MdOutlineDataArray />, 'Add Array Node'),
        MenuItem(ActionType.ADD_CHILD_PHANTOM_NODE, <FaElementor color={'#aaa'} />, 'Add Phantom Node'),
        MenuItem(ActionType.ADD_CHILD_PHANTOM_ARRAY_NODE, <MdOutlineDataArray color={'#aaa'} />, 'Add Phantom Array Node'),
        MenuItem(ActionType.ADD_CHILD_CDATA, <RxTextAlignJustify />, 'Add CDATA'),
        MenuItem(ActionType.ADD_CHILD_STATIC_BOOLEAN, <RxComponentBoolean />, 'Add Static Boolean Node'),
        MenuItem(ActionType.ADD_CHILD_MAPPED_BOOLEAN, <VscSymbolBoolean />, 'Add Mapped Boolean Node'),
        MenuItem(ActionType.ADD_CHILD_STATIC_NUMBER, <RiNumber1 />, 'Add Static Number Node'),
        MenuItem(ActionType.ADD_CHILD_MAPPED_NUMBER, <TbHexagonNumber1Filled />, 'Add Mapped Number Node'),
        MenuItem(ActionType.ADD_CHILD_SEQUENCE_NUMBER, <TbCircleNumber1Filled />, 'Add Sequence Number Node'),
        MenuItem(ActionType.ADD_CHILD_STATIC_TEXT, <RxText />, 'Add Static Text Node'),
        MenuItem(ActionType.ADD_CHILD_MAPPED_TEXT, <FaHashnode />, 'Add Mapped Text Node'),
        MenuItem(ActionType.ADD_CHILD_SEQUENCE_TEXT, <TbCircleNumber1 />, 'Add Sequence Text Node'),
        MenuItem(ActionType.ADD_ATTRIBUTE, <FaCircle />, 'Add Attribute'),
        MenuItem(ActionType.ADD_MAPPED_ATTRIBUTE, <FaCircleDot />, 'Add Mapped Attribute'),
        MenuItem(ActionType.ADD_SEQUENCE_ATTRIBUTE, <FaRegCircle />, 'Add Sequence Attribute'),
    ]),
    Menu(ActionType.ABOVE_NODE, <FaPlus color={'#015b93'}/>, 'Add Child Node Above', [
        MenuItem(ActionType.ADD_SIBLING_NODE_ABOVE, <FaElementor />, 'Add Node'),
        MenuItem(ActionType.ADD_SIBLING_ARRAY_NODE_ABOVE, <MdOutlineDataArray />, 'Add Array Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_NODE_ABOVE, <FaElementor color={'#aaa'} />, 'Add Phantom Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_ARRAY_NODE_ABOVE, <MdOutlineDataArray color={'#aaa'} />, 'Add Phantom Array Node'),
        MenuItem(ActionType.ADD_SIBLING_CDATA_ABOVE, <RxTextAlignJustify />, 'Add CDATA'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_BOOLEAN_ABOVE, <RxComponentBoolean />, 'Add Static Boolean Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_BOOLEAN_ABOVE, <VscSymbolBoolean />, 'Add Mapped Boolean Node'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_NUMBER_ABOVE, <RiNumber1 />, 'Add Static Number Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_NUMBER_ABOVE, <TbHexagonNumber1Filled />, 'Add Mapped Number Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_NUMBER_ABOVE, <TbCircleNumber1Filled  />, 'Add Sequence Number Node'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_TEXT_ABOVE, <RxText />, 'Add Static Text Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_TEXT_ABOVE, <FaHashnode />, 'Add Mapped Tdxt Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_TEXT_ABOVE, <TbCircleNumber1/>, 'Add Sequence Text Node'),
        MenuItem(ActionType.ADD_SIBLING_ATTRIBUTE_ABOVE, <FaCircle />, 'Add Attribute'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_ATTRIBUTE_ABOVE, <FaCircleDot />, 'Add Mapped Attribute'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_ATTRIBUTE_ABOVE, <FaRegCircle />, 'Add Sequence Attribute'),
    ]),
    Menu(ActionType.BELOW_NODE, <FaPlus color={'#015b93'}/>, 'Add Child Node Below', [
        MenuItem(ActionType.ADD_SIBLING_NODE_BELOW, <FaElementor />, 'Add Node'),
        MenuItem(ActionType.ADD_SIBLING_ARRAY_NODE_BELOW, <MdOutlineDataArray />, 'Add Array Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_NODE_BELOW, <FaElementor color={'#aaa'} />, 'Add Phantom Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_ARRAY_NODE_BELOW, <MdOutlineDataArray color={'#aaa'} />, 'Add Phantom Array Node'),
        MenuItem(ActionType.ADD_SIBLING_CDATA_BELOW, <RxTextAlignJustify />, 'Add CDATA'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_BOOLEAN_BELOW, <RxComponentBoolean />, 'Add Static Boolean Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_BOOLEAN_BELOW, <VscSymbolBoolean />, 'Add Mapped Boolean Node'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_NUMBER_BELOW, <RiNumber1 />, 'Add Static Number Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_NUMBER_BELOW, <TbHexagonNumber1Filled />, 'Add Mapped Number Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_NUMBER_BELOW, <TbCircleNumber1Filled />, 'Add Sequence Number Node'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_TEXT_BELOW, <RxText />, 'Add Static Text Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_TEXT_BELOW, <FaHashnode />, 'Add Mapped Text Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_TEXT_BELOW, <TbCircleNumber1 />, 'Add Sequence Node'),
        MenuItem(ActionType.ADD_SIBLING_ATTRIBUTE_BELOW, <FaCircle />, 'Add Attribute'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_ATTRIBUTE_BELOW, <FaCircleDot />, 'Add Mapped Attribute'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_ATTRIBUTE_BELOW, <FaRegCircle />, 'Add Sequence Attribute'),
    ]),
    Menu(ActionType.CHANGE_NODE_TYPE, <AiOutlineEdit color={'#015b93'}/>, 'Change Node Type', [
        MenuItem(ActionType.CHANGE_TO_NODE, <FaElementor />, 'Change to Node'),
        MenuItem(ActionType.CHANGE_TO_ARRAY_NODE, <MdOutlineDataArray />, 'Change to Array Node'),
        MenuItem(ActionType.CHANGE_TO_PHANTOM_NODE, <FaElementor color={'#aaa'} />, 'Change to Phantom Node'),
        MenuItem(ActionType.CHANGE_TO_PHANTOM_ARRAY_NODE, <FaElementor color={'#aaa'} />, 'Change to Phantom Array Node'),
        MenuItem(ActionType.CHANGE_TO_CDATA, <RxTextAlignJustify />, 'Change to CDATA'),
        MenuItem(ActionType.CHANGE_TO_STATIC_BOOLEAN, <RxComponentBoolean />, 'Change to Static Boolean Node'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_BOOLEAN, <VscSymbolBoolean />, 'Change to Mapped Boolean Node'),
        MenuItem(ActionType.CHANGE_TO_STATIC_NUMBER, <RiNumber1 />, 'Change to Static Number Node'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_NUMBER, <TbHexagonNumber1Filled />, 'Change to Mapped Number Node'),
        MenuItem(ActionType.CHANGE_TO_SEQUENCE_NUMBER, <TbCircleNumber1Filled />, 'Change to Sequence NUmber Node'),
        MenuItem(ActionType.CHANGE_TO_STATIC_TEXT, <RxText />, 'Change to Static Text Node'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_TEXT, <FaHashnode />, 'Change to Mapped Text Node'),
        MenuItem(ActionType.CHANGE_TO_SEQUENCE_TEXT, <TbCircleNumber1 />, 'Change to Sequence Text Node'),
        MenuItem(ActionType.CHANGE_TO_ATTRIBUTE, <FaCircle />, 'Change to Attribute'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_ATTRIBUTE, <FaCircleDot />, 'Change to Mapped Attribute'),
        MenuItem(ActionType.CHANGE_TO_SEQUENCE_ATTRIBUTE, <FaRegCircle />, 'Change to Sequence Attribute'),
    ]),
    MenuItem(ActionType.DELETE_NODE, <AiOutlineDelete color={'#015b93'}/>, 'Delete Node')
];

export const cdataItems = [
    Menu(ActionType.NODE, <FaPlus color={'#015b93'}/>, 'Add Child Node', [
        MenuItem(ActionType.ADD_CHILD_NODE, <FaElementor />, 'Add Node'),
        MenuItem(ActionType.ADD_CHILD_ARRAY_NODE, <MdOutlineDataArray />, 'Add Array Node'),
        MenuItem(ActionType.ADD_CHILD_PHANTOM_NODE, <FaElementor color={'#aaa'} />, 'Add Phantom Node'),
        MenuItem(ActionType.ADD_CHILD_PHANTOM_ARRAY_NODE, <MdOutlineDataArray color={'#aaa'} />, 'Add Phantom Array Node'),
        MenuItem(ActionType.ADD_CHILD_STATIC_TEXT, <RxText />, 'Add Static Text Node'),
        MenuItem(ActionType.ADD_CHILD_MAPPED_TEXT, <FaHashnode />, 'Add Mapped Node'),
        MenuItem(ActionType.ADD_CHILD_SEQUENCE_TEXT, <TbCircleNumber1 />, 'Add Sequence Text Node'),
    ]),
    Menu(ActionType.ABOVE_NODE, <FaPlus color={'#015b93'}/>, 'Add Child Node Above', [
        MenuItem(ActionType.ADD_SIBLING_NODE_ABOVE, <FaElementor />, 'Add Node'),
        MenuItem(ActionType.ADD_SIBLING_ARRAY_NODE_ABOVE, <MdOutlineDataArray />, 'Add Array Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_NODE_ABOVE, <FaElementor color={'#aaa'} />, 'Add Phantom Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_ARRAY_NODE_ABOVE, <MdOutlineDataArray color={'#aaa'} />, 'Add Phantom Array Node'),
        MenuItem(ActionType.ADD_SIBLING_CDATA_ABOVE, <RxTextAlignJustify />, 'Add CDATA'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_TEXT_ABOVE, <RxText />, 'Add Static Text Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_TEXT_ABOVE, <FaHashnode />, 'Add Mapped Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_TEXT_ABOVE, <TbCircleNumber1 />, 'Add Sequence Text Node'),
        MenuItem(ActionType.ADD_SIBLING_ATTRIBUTE_ABOVE, <FaCircle />, 'Add Attribute'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_ATTRIBUTE_ABOVE, <FaCircleDot />, 'Add Mapped Attribute'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_ATTRIBUTE_ABOVE, <FaRegCircle />, 'Add Sequence Attribute'),
    ]),
    Menu(ActionType.BELOW_NODE, <FaPlus color={'#015b93'}/>, 'Add Child Node Below', [
        MenuItem(ActionType.ADD_SIBLING_NODE_BELOW, <FaElementor />, 'Add Node'),
        MenuItem(ActionType.ADD_SIBLING_ARRAY_NODE_BELOW, <MdOutlineDataArray />, 'Add Array Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_NODE_BELOW, <FaElementor color={'#aaa'} />, 'Add Phantom Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_ARRAY_NODE_BELOW, <MdOutlineDataArray color={'#aaa'} />, 'Add Phantom Array Node'),
        MenuItem(ActionType.ADD_SIBLING_CDATA_BELOW, <RxTextAlignJustify />, 'Add CDATA'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_TEXT_BELOW, <RxText />, 'Add Static Text Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_TEXT_BELOW, <FaHashnode />, 'Add Mapped Text Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_TEXT_BELOW, <TbCircleNumber1 />, 'Add Sequence Text Node'),
        MenuItem(ActionType.ADD_SIBLING_ATTRIBUTE_BELOW, <FaCircle />, 'Add Attribute'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_ATTRIBUTE_BELOW, <FaCircleDot />, 'Add Mapped Attribute'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_ATTRIBUTE_BELOW, <FaRegCircle />, 'Add Sequence Attribute'),
    ]),
    Menu(ActionType.CHANGE_NODE_TYPE, <AiOutlineEdit color={'#015b93'}/>, 'Change Node Type', [
        MenuItem(ActionType.CHANGE_TO_NODE, <FaElementor />, 'Change to Node'),
        MenuItem(ActionType.CHANGE_TO_ARRAY_NODE, <MdOutlineDataArray />, 'Change to Array Node'),
        MenuItem(ActionType.CHANGE_TO_PHANTOM_NODE, <FaElementor color={'#aaa'} />, 'Change to Phantom Node'),
        MenuItem(ActionType.CHANGE_TO_PHANTOM_ARRAY_NODE, <FaElementor color={'#aaa'} />, 'Change to Phantom Array Node'),
        MenuItem(ActionType.CHANGE_TO_CDATA, <RxTextAlignJustify />, 'Change to CDATA'),
        MenuItem(ActionType.CHANGE_TO_STATIC_TEXT, <RxText />, 'Change to Static Text Node'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_TEXT, <FaHashnode />, 'Change to Mapped Text Node'),
        MenuItem(ActionType.CHANGE_TO_SEQUENCE_TEXT, <TbCircleNumber1 />, 'Change to Sequence Text Node'),
        MenuItem(ActionType.CHANGE_TO_ATTRIBUTE, <FaCircle />, 'Change to Attribute'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_ATTRIBUTE, <FaCircleDot />, 'Change to Mapped Attribute'),
        MenuItem(ActionType.CHANGE_TO_SEQUENCE_ATTRIBUTE, <FaRegCircle />, 'Change to Sequence Attribute'),
    ]),
    MenuItem(ActionType.DELETE_NODE, <AiOutlineDelete color={'#015b93'}/>, 'Delete Node')
];

export const leafNodeItems = [
    Menu(ActionType.ABOVE_NODE, <FaPlus color={'#015b93'}/>, 'Add Child Node Above', [
        MenuItem(ActionType.ADD_SIBLING_NODE_ABOVE, <FaElementor />, 'Add Node'),
        MenuItem(ActionType.ADD_SIBLING_ARRAY_NODE_ABOVE, <MdOutlineDataArray />, 'Add Array Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_NODE_ABOVE, <FaElementor color={'#aaa'} />, 'Add Phantom Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_ARRAY_NODE_ABOVE, <MdOutlineDataArray color={'#aaa'} />, 'Add Phantom Array Node'),
        MenuItem(ActionType.ADD_SIBLING_CDATA_ABOVE, <RxTextAlignJustify />, 'Add CDATA'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_BOOLEAN_ABOVE, <RxComponentBoolean />, 'Add Static Boolean Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_BOOLEAN_ABOVE, <VscSymbolBoolean />, 'Add Mapped Boolean Node'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_NUMBER_ABOVE, <RiNumber1 />, 'Add Static Number Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_NUMBER_ABOVE, <TbHexagonNumber1Filled />, 'Add Mapped Number Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_NUMBER_ABOVE, <TbCircleNumber1Filled />, 'Add Sequence Number Node'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_TEXT_ABOVE, <RxText />, 'Add Static Text Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_TEXT_ABOVE, <FaHashnode />, 'Add Mapped Text Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_TEXT_ABOVE, <TbCircleNumber1 />, 'Add Sequence Text Node'),
    ]),
    Menu(ActionType.BELOW_NODE, <FaPlus color={'#015b93'}/>, 'Add Child Node Below', [
        MenuItem(ActionType.ADD_SIBLING_NODE_BELOW, <FaElementor />, 'Add Node'),
        MenuItem(ActionType.ADD_SIBLING_ARRAY_NODE_BELOW, <MdOutlineDataArray />, 'Add Array Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_NODE_BELOW, <FaElementor color={'#aaa'} />, 'Add Phantom Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_ARRAY_NODE_BELOW, <MdOutlineDataArray color={'#aaa'} />, 'Add Phantom Array Node'),
        MenuItem(ActionType.ADD_SIBLING_CDATA_BELOW, <RxTextAlignJustify />, 'Add CDATA'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_BOOLEAN_BELOW, <RxComponentBoolean />, 'Add Static Boolean Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_BOOLEAN_BELOW, <VscSymbolBoolean />, 'Add Mapped Boolean Node'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_NUMBER_BELOW, <RiNumber1 />, 'Add Static Number Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_NUMBER_BELOW, <TbHexagonNumber1Filled />, 'Add Mapped Number Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_NUMBER_BELOW, <TbCircleNumber1Filled />, 'Add Sequence Number Node'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_TEXT_BELOW, <RxText />, 'Add Static Text Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_TEXT_BELOW, <FaHashnode />, 'Add Mapped Text Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_TEXT_BELOW, <TbCircleNumber1 />, 'Add Sequence Text Node'),
    ]),
    Menu(ActionType.CHANGE_NODE_TYPE, <AiOutlineEdit color={'#015b93'}/>, 'Change Node Type', [
        MenuItem(ActionType.CHANGE_TO_NODE, <FaElementor />, 'Change to Node'),
        MenuItem(ActionType.CHANGE_TO_ARRAY_NODE, <MdOutlineDataArray />, 'Change to Array Node'),
        MenuItem(ActionType.CHANGE_TO_PHANTOM_NODE, <FaElementor color={'#aaa'} />, 'Change to Phantom Node'),
        MenuItem(ActionType.CHANGE_TO_PHANTOM_ARRAY_NODE, <FaElementor color={'#aaa'} />, 'Change to Phantom Array Node'),
        MenuItem(ActionType.CHANGE_TO_CDATA, <RxTextAlignJustify />, 'Change to CDATA'),
        MenuItem(ActionType.CHANGE_TO_STATIC_BOOLEAN, <RxComponentBoolean />, 'Change to Static Boolean Node'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_BOOLEAN, <VscSymbolBoolean />, 'Change to Mapped Boolean Node'),
        MenuItem(ActionType.CHANGE_TO_STATIC_NUMBER, <RiNumber1 />, 'Change to Static Number Node'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_NUMBER, <TbHexagonNumber1Filled />, 'Change to Mapped Number Node'),
        MenuItem(ActionType.CHANGE_TO_SEQUENCE_NUMBER, <TbCircleNumber1Filled />, 'Change to Sequence Number Node'),
        MenuItem(ActionType.CHANGE_TO_STATIC_TEXT, <RxText />, 'Change to Static Text Node'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_TEXT, <FaHashnode />, 'Change to Mapped Text Node'),
        MenuItem(ActionType.CHANGE_TO_SEQUENCE_TEXT, <TbCircleNumber1 />, 'Change to Sequence Text Node'),
        MenuItem(ActionType.CHANGE_TO_ATTRIBUTE, <FaCircle />, 'Change to Attribute'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_ATTRIBUTE, <FaCircleDot />, 'Change to Mapped Attribute'),
        MenuItem(ActionType.CHANGE_TO_SEQUENCE_ATTRIBUTE, <FaRegCircle />, 'Change to Sequence Attribute'),
    ]),
    MenuItem(ActionType.ADD_ATTRIBUTE, <FaCircle color={'#015b93'} />, 'Add Attribute'),
    MenuItem(ActionType.ADD_MAPPED_ATTRIBUTE, <FaCircleDot color={'#015b93'} />, 'Add Mapped Attribute'),
    MenuItem(ActionType.ADD_SEQUENCE_ATTRIBUTE, <FaRegCircle color={'#015b93'} />, 'Add Sequence Attribute'),
    MenuItem(ActionType.DELETE_NODE, <AiOutlineDelete color={'#015b93'}/>, 'Delete Node')
];

export const attributeItems = [
    Menu(ActionType.ABOVE_NODE, <FaPlus color={'#015b93'}/>, 'Add Child Node Above', [
        MenuItem(ActionType.ADD_SIBLING_NODE_ABOVE, <FaElementor />, 'Add Node'),
        MenuItem(ActionType.ADD_SIBLING_ARRAY_NODE_ABOVE, <MdOutlineDataArray />, 'Add Array Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_NODE_ABOVE, <FaElementor color={'#aaa'}/>, 'Add Phantom Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_ARRAY_NODE_ABOVE, <MdOutlineDataArray color={'#aaa'} />, 'Add Phantom Array Node'),
        MenuItem(ActionType.ADD_SIBLING_CDATA_ABOVE, <RxTextAlignJustify />, 'Add CDATA'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_BOOLEAN_ABOVE, <RxComponentBoolean />, 'Add Static Boolean Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_BOOLEAN_ABOVE, <VscSymbolBoolean />, 'Add Mapped Boolean Node'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_NUMBER_ABOVE, <RiNumber1 />, 'Add Static Number Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_NUMBER_ABOVE, <TbHexagonNumber1Filled />, 'Add Mapped Number Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_NUMBER_ABOVE, <TbCircleNumber1Filled />, 'Add Sequence Number Node'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_TEXT_ABOVE, <RxText />, 'Add Static Text Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_TEXT_ABOVE, <FaHashnode />, 'Add Mapped Text Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_TEXT_ABOVE, <TbCircleNumber1 />, 'Add Sequence Text Node'),
        MenuItem(ActionType.ADD_SIBLING_ATTRIBUTE_ABOVE, <FaCircle />, 'Add Attribute'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_ATTRIBUTE_ABOVE, <FaCircleDot />, 'Add Mapped Attribute'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_ATTRIBUTE_ABOVE, <FaRegCircle />, 'Add Sequence Attribute'),
    ]),
    Menu(ActionType.BELOW_NODE, <FaPlus color={'#015b93'}/>, 'Add Child Node Below', [
        MenuItem(ActionType.ADD_SIBLING_NODE_BELOW, <FaElementor />, 'Add Node'),
        MenuItem(ActionType.ADD_SIBLING_ARRAY_NODE_BELOW, <MdOutlineDataArray />, 'Add Array Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_NODE_BELOW, <FaElementor color={'#aaa'} />, 'Add Phantom Node'),
        MenuItem(ActionType.ADD_SIBLING_PHANTOM_ARRAY_NODE_BELOW, <MdOutlineDataArray color={'#aaa'} />, 'Add Phantom Array Node'),
        MenuItem(ActionType.ADD_SIBLING_CDATA_BELOW, <RxTextAlignJustify />, 'Add CDATA'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_BOOLEAN_BELOW, <RxComponentBoolean />, 'Add Static Boolean Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_BOOLEAN_BELOW, <VscSymbolBoolean />, 'Add Mapped Boolean Node'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_NUMBER_BELOW, <RiNumber1 />, 'Add Static Number Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_NUMBER_BELOW, <TbHexagonNumber1Filled />, 'Add Mapped Number Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_NUMBER_BELOW, <TbCircleNumber1Filled />, 'Add Sequence Number Node'),
        MenuItem(ActionType.ADD_SIBLING_STATIC_TEXT_BELOW, <RxText />, 'Add Static Text Node'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_TEXT_BELOW, <FaHashnode />, 'Add Mapped Text Node'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_TEXT_BELOW, <TbCircleNumber1 />, 'Add Sequence Text Node'),
        MenuItem(ActionType.ADD_SIBLING_ATTRIBUTE_BELOW, <FaCircle />, 'Add Attribute'),
        MenuItem(ActionType.ADD_SIBLING_MAPPED_ATTRIBUTE_BELOW, <FaCircleDot />, 'Add Mapped Attribute'),
        MenuItem(ActionType.ADD_SIBLING_SEQUENCE_ATTRIBUTE_BELOW, <FaRegCircle />, 'Add Sequence Attribute'),
    ]),
    Menu(ActionType.CHANGE_NODE_TYPE, <AiOutlineEdit color={'#015b93'}/>, 'Change Node Type', [
        MenuItem(ActionType.CHANGE_TO_NODE, <FaElementor />, 'Change to Node'),
        MenuItem(ActionType.CHANGE_TO_ARRAY_NODE, <MdOutlineDataArray />, 'Change to Array Node'),
        MenuItem(ActionType.CHANGE_TO_PHANTOM_NODE, <FaElementor color={'#aaa'} />, 'Change to Phantom Node'),
        MenuItem(ActionType.CHANGE_TO_PHANTOM_ARRAY_NODE, <FaElementor color={'#aaa'} />, 'Change to Phantom Array Node'),
        MenuItem(ActionType.CHANGE_TO_CDATA, <RxTextAlignJustify />, 'Change to CDATA'),
        MenuItem(ActionType.CHANGE_TO_STATIC_BOOLEAN, <RxComponentBoolean />, 'Change to Static Boolean Node'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_BOOLEAN, <VscSymbolBoolean />, 'Change to Mapped Boolean Node'),
        MenuItem(ActionType.CHANGE_TO_STATIC_NUMBER, <RiNumber1 />, 'Change to Static Number Node'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_NUMBER, <TbHexagonNumber1Filled />, 'Change to Mapped Number Node'),
        MenuItem(ActionType.CHANGE_TO_SEQUENCE_NUMBER, <TbCircleNumber1Filled />, 'Change to Sequence Number Node'),
        MenuItem(ActionType.CHANGE_TO_STATIC_TEXT, <RxText />, 'Change to Static Text Node'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_TEXT, <FaHashnode />, 'Change to Mapped Text Node'),
        MenuItem(ActionType.CHANGE_TO_SEQUENCE_TEXT, <TbCircleNumber1 />, 'Change to Sequence Text Node'),
        MenuItem(ActionType.CHANGE_TO_ATTRIBUTE, <FaCircle />, 'Change to Attribute'),
        MenuItem(ActionType.CHANGE_TO_MAPPED_ATTRIBUTE, <FaCircleDot />, 'Change to Mapped Attribute'),
        MenuItem(ActionType.CHANGE_TO_SEQUENCE_ATTRIBUTE, <FaRegCircle />, 'Change to Sequence Attribute'),
    ]),
    MenuItem(ActionType.DELETE_NODE, <AiOutlineDelete color={'#015b93'}/>, 'Delete Node')
];